export function getReadingTimeFromWords(wordCount) {
  const minutes = Math.ceil(wordCount / 200);
  return `${minutes} min read`;
}